export default __webpack_public_path__ + "static/media/darklogo.d943f6e5.png";